var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSSTransition } from "react-transition-group";
import { faAddressBook, faEye, faSquareChevronDown, faSquareChevronLeft, faSquareChevronRight, faSquareChevronUp, } from "@fortawesome/pro-solid-svg-icons";
import { Slot } from "@/utils/types/layout";
import { useLayout, usePopup } from "@/hooks/layout";
import { useLongPress } from "@uidotdev/usehooks";
import React from "react";
import { useGetModuleBuilderLayoutQuery, useGetModuleFieldsQuery, useGetModuleRecordQuery, } from "@/store/api";
import { useAppSelector } from "@/hooks/store";
import { getUserPreferences } from "@/store/utils/selectors/userSelector";
var preview = function Preview(_a) {
    var _this = this;
    var record = _a.record, recordId = _a.recordId, handleClick = _a.handleClick, module = _a.module, className = _a.className, _b = _a.color, color = _b === void 0 ? "gray-300" : _b, isInDrawer = _a.isInDrawer, paddingClassname = _a.paddingClassname;
    // Get field_defs
    var listFields = useGetModuleFieldsQuery(module || "").data;
    var field_defs = (listFields && (listFields === null || listFields === void 0 ? void 0 : listFields.data.attributes)) || [];
    // Get view_defs
    var viewDefs = useGetModuleBuilderLayoutQuery({
        moduleName: module || "",
        layout: "detailviewdefs",
    }).data;
    var _c = useState({}), layoutMeta = _c[0], setLayoutMeta = _c[1];
    useEffect(function () {
        var view_defs = viewDefs || {};
        var viewDefsData = view_defs.data || {};
        var layoutMetaValue = viewDefsData.layout || {};
        setLayoutMeta(layoutMetaValue);
    }, [viewDefs]);
    // Get record object
    var response = useGetModuleRecordQuery({
        moduleName: module || "",
        recordId: recordId,
    }).data;
    var _d = useState({}), dataRecord = _d[0], setDataRecord = _d[1];
    useEffect(function () {
        setDataRecord(response === null || response === void 0 ? void 0 : response.data.record);
    }, [response]);
    // Use long press
    var _e = useState(false), showPreviewDirection = _e[0], setShowPreviewDirection = _e[1];
    var _f = useState({}), bean = _f[0], setBean = _f[1];
    var attrs = useLongPress(function () {
        setShowPreviewDirection(true);
        setBean(record || dataRecord);
    }, {
        threshold: 500,
    });
    // Display record on preview
    var layout = useLayout();
    var popup = usePopup();
    var showPreview = function (record, slot, m) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    layout.clearWidgets({
                        slots: slot,
                    });
                    handleClick(true);
                    setShowPreviewDirection(false);
                    return [4 /*yield*/, popup.showPopup({
                            type: "widget/module/detail",
                            slot: slot,
                            payload: {
                                record: record || dataRecord,
                                module: m,
                                isPreview: true,
                                field_defs: field_defs,
                                view_defs: layoutMeta,
                            },
                        })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var showContact = function (slot) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    layout.clearWidgets({
                        slots: slot,
                    });
                    handleClick(true);
                    setShowPreviewDirection(false);
                    return [4 /*yield*/, popup.showPopup({
                            id: "",
                            type: "widget/list",
                            slot: slot,
                            payload: {
                                module: module,
                                first: "%(name)s",
                                recordId: recordId,
                            },
                        })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var nodeRef = useRef(null);
    /**
     * Hook that alerts clicks outside of the passed ref
     */
    function useOutsideAlerter(ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowPreviewDirection(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    useOutsideAlerter(nodeRef);
    var userPreferences = useAppSelector(getUserPreferences);
    var perviewDirection = (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.display_preview_direction) || "east";
    var slotDirectionPreview = perviewDirection === "north"
        ? Slot.PREVIEW_NORTH
        : perviewDirection === "south"
            ? Slot.PREVIEW_SOUTH
            : perviewDirection === "west"
                ? Slot.PREVIEW_WEST
                : Slot.PREVIEW_EAST;
    return (_jsxs("div", { children: [_jsx("button", __assign({ className: "pt-2", onClick: function () {
                    isInDrawer
                        ? showContact(Slot.DRAWER_EAST)
                        : showPreview(record || dataRecord, slotDirectionPreview, module);
                } }, attrs, { children: _jsx(FontAwesomeIcon, { icon: isInDrawer ? faAddressBook : faEye, className: "".concat(paddingClassname ? paddingClassname : "pl-1", "  cursor-pointer  hover:text-gray-500 text-").concat(color, "  ").concat(className) }) })), showPreviewDirection && (_jsx(CSSTransition, __assign({ timeout: 500, nodeRef: nodeRef, classNames: "alert" }, { children: _jsx("div", __assign({ ref: nodeRef, className: "absolute left-0 w-full h-full inline-flex backdrop-blur-sm bg-white/30" }, { children: _jsxs("div", __assign({ className: "absolute left-0 right-0 text-center space-x-2 mt-2" }, { children: [_jsx(FontAwesomeIcon, { icon: faSquareChevronLeft, size: "lg", onClick: function () {
                                    return isInDrawer
                                        ? showContact(Slot.DRAWER_EAST)
                                        : showPreview(bean, Slot.PREVIEW_EAST, module);
                                }, className: " cursor-pointer h-4" }), _jsx(FontAwesomeIcon, { icon: faSquareChevronUp, size: "lg", onClick: function () {
                                    return isInDrawer
                                        ? showContact(Slot.DRAWER_SOUTH)
                                        : showPreview(bean, Slot.PREVIEW_SOUTH, module);
                                }, className: "cursor-pointer h-4 " }), _jsx(FontAwesomeIcon, { icon: faSquareChevronDown, size: "lg", onClick: function () {
                                    return isInDrawer
                                        ? showContact(Slot.DRAWER_NORTH)
                                        : showPreview(bean, Slot.PREVIEW_NORTH, module);
                                }, className: "cursor-pointer h-4" }), _jsx(FontAwesomeIcon, { icon: faSquareChevronRight, size: "lg", onClick: function () {
                                    return isInDrawer
                                        ? showContact(Slot.DRAWER_WEST)
                                        : showPreview(bean, Slot.PREVIEW_WEST, module);
                                }, className: "cursor-pointer h-4" })] })) })) }), (record === null || record === void 0 ? void 0 : record.id) || (dataRecord === null || dataRecord === void 0 ? void 0 : dataRecord.id) || recordId))] }));
};
export default React.memo(preview);
